import React, { useEffect, useState } from "react";
import ArrowBack from "@mui/icons-material/ArrowBackIos";
import ArrowForward from "@mui/icons-material/ArrowForwardIos";
import TranslateIcon from "@mui/icons-material/Translate";
import { Button, Stack, Typography } from "@mui/joy";
import { useNavigate, useLocation } from "react-router-dom";
import { getI18n } from "react-i18next";
import Logo from "../../images/logo.png";
import useAppStore from "../../store/appStore";

export default function Navbar() {
  const [hasBack, setHasBack] = useState(false);
  const { isRTL, setLanguage } = useAppStore();
  const navigate = useNavigate();
  const location = useLocation();
  const i18n = getI18n();

  const handleLanguageChange = () => {
    const currentLanguage = i18n.language;
    const newLanguage = currentLanguage === "en" ? "ar" : "en";
    i18n.changeLanguage(newLanguage);
    setLanguage(newLanguage);
  };

  useEffect(() => {
    // Update hasBack whenever location changes
    const updateBackButton = () => {
      if (location.pathname === "/" || location.pathname === "/thank-you") {
        setHasBack(false);
      } else {
        const state = window.history.state;
        // Check both history state and navigation type
        setHasBack(state?.idx > 0 || state?.usr?.source === "push");
      }
    };

    updateBackButton();
  }, [location]); // Re-run effect when location changes

  return (
    <nav className="bg-gray-800 p-4">
      <Stack direction="row" spacing={2}>
        {hasBack && (
          <Button
            variant="text"
            onClick={() => navigate(-1)}
            sx={{ color: "white" }}
          >
            {isRTL ? <ArrowForward /> : <ArrowBack />}
          </Button>
        )}
        <div className="flex w-full">
          <img src={Logo} alt="logo" className="h-10 mx-auto" />
        </div>
        <Button
          variant="text"
          onClick={handleLanguageChange}
          sx={{ color: "white" }}
        >
          <div className="flex items-center" style={{direction: 'ltr'}}>
            <TranslateIcon />{" "}
            <Typography level="body-sm">
              {i18n.language === "en" ? "AR" : "EN"}
            </Typography>
          </div>
        </Button>
      </Stack>
    </nav>
  );
}
